module.exports = __webpack_public_path__ + "img/monkey.c9bb5ae5.png";